export const SuccessMessage = 'Action completed successfully';
export const ErrorMessage = 'An error has occurred';
export const ExistsMessage = 'Record already exists';
export const ConnectToInternetMessage = 'Please connect to the internet to continue.';
